import { CalendarEvent, compareCalendarEvents } from 'owa-calendar-types';
import { differenceInMilliseconds, startOfDay } from 'owa-datetime';
import { getVisualDaySpan } from 'owa-calendar-events-visual-date-range';

/**
 * Compares two surface items
 * @param {CalendarEvent} item1 first item to compare
 * @param {CalendarEvent} item2 second item to compare
 * @returns positive number if item1 > item2, otherwise returns negative number
 */
export function compareSurfaceItems(item1: CalendarEvent, item2: CalendarEvent): number {
    // First sort by day
    const startDayItem1 = startOfDay(item1.Start);
    const startDayItem2 = startOfDay(item2.Start);
    const comp = differenceInMilliseconds(startDayItem1, startDayItem2);
    if (comp != 0) {
        return comp;
    }

    // multi-day events come before non-multiday events if the start day is the same in month view
    const diff = getVisualDaySpan(item2) - getVisualDaySpan(item1);
    if (diff != 0) {
        return diff;
    }

    // If same day, use normal sort method
    return compareCalendarEvents(item1, item2);
}
